import apiFetch from '../../../utils/apiFetch';

const post = async (url, body, fallback) => {
  const response = await apiFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.message || fallback);
  return result;
};
const base = campaignId => `/campaigns/${encodeURIComponent(campaignId)}/cast-windows`;

/** The DM's enemy is casting: open a window, or learn nobody can react. */
export const openCastWindow = (campaignId, cast) => post(base(campaignId), cast, 'The Reaction window could not be opened.');
/** A character casts or declines (`helperId`); the DM skips (no `helperId`). */
export const decideCastWindow = (campaignId, windowId, body) =>
  post(`${base(campaignId)}/${encodeURIComponent(windowId)}/decide`, body, 'The Reaction could not be saved.');
/** The DM follows one window (`windowId`); a player lists the windows their character may answer (`characterId`). */
export const syncCastWindows = (campaignId, body) => post(`${base(campaignId)}/sync`, body, 'Reaction windows could not be loaded.');
